import { Heading } from "@biblioteksentralen/react";
import { digitalLibraryServiceCategories } from "@libry-content/common";
import { objectKeys } from "@libry-content/types";
import { group, sort } from "radash";
import { DigitalLibraryPageProps } from "../../app/[locale]/sites/[siteDomain]/digitalt-bibliotek/page";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { DefaultContainer } from "../ContentContainer";
import { CreateNew } from "../editInSanity/EditInSanity";
import { ServicesLink } from "../site/banners/ServicesAndDigitalServicesBanner";
import { DigitalLibraryServiceCategoriesDesktop } from "./DigitalLibraryServiceCategoriesDesktop";
import { DigitalLibraryServiceCategoriesMobile } from "./DigitalLibraryServiceCategoriesMobile";
import { CategoryWithDigitalLibraryServices } from "./utils";

const digitalLibraryServiceCategoryKeys = objectKeys(digitalLibraryServiceCategories);

const orderByCategory = (items: CategoryWithDigitalLibraryServices[]): CategoryWithDigitalLibraryServices[] =>
  sort(items, ([category]) => digitalLibraryServiceCategoryKeys.indexOf(category));

export const DigitalLibraryServicesListView = ({ services, digitalLibraryServices }: DigitalLibraryPageProps) => {
  const { t } = useTranslation();

  const servicesByCategory = orderByCategory(
    Object.entries(group(digitalLibraryServices, ({ category }) => category || "")).filter(
      ([category]) => !!category
    ) as CategoryWithDigitalLibraryServices[]
  );

  return (
    <>
      <DefaultContainer>
        <Heading as="h1" marginBottom={{ base: "2rem", lg: "3rem" }}>
          {t("Bruk biblioteket hjemmefra")}
        </Heading>
        <CreateNew type="digitalLibraryCustomService" position="relative" bottom="1rem" />
        <DigitalLibraryServiceCategoriesDesktop
          display={{ base: "none", lg: "initial" }}
          servicesByCategory={servicesByCategory}
        />
        <DigitalLibraryServiceCategoriesMobile
          display={{ base: "initial", lg: "none" }}
          servicesByCategory={servicesByCategory}
        />
      </DefaultContainer>
      <DefaultContainer as="section" marginTop="6rem">
        <ServicesLink />
      </DefaultContainer>
    </>
  );
};
